import * as React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme, createStyles, CircularProgress } from '@material-ui/core';
import { } from '../HOC/Transition';
import strings from 'src/strings';
import { LoginAPI, getDefaultDevice, User, APIError, APIErrorType } from 'src/api';
import KDInput from '../Input/Input';
import KDGlobal from '../Global';
import WelcomeHeader from '../Header/WelcomeHeader';
import { defaultView, DefaultView } from '../HOC';


interface LoginState {
    loading?: boolean,
    errors: { email?: boolean, password?: boolean }
    email: string,
    password: string,
}

class Login extends React.Component<WithStyles<typeof styles> & DefaultView, LoginState> {

    constructor(props: any) {
        super(props);
        this.state = {
            errors: {

            },
            email: '',
            password: ''

        }
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.message) {
            this.props.showToast(this.props.location.state.message.type, this.props.location.state.message.message)
        }
    }

    private onLoginClick() {
        if (!this.state.email) {
            this.props.showToast('error', strings.error_provideEmail)
            this.setState({ errors: { email: true } })
        } else if (this.state.email!.indexOf('@') === -1) {
            this.props.showToast('error', strings.error_invalidEmail)
            this.setState({ errors: { email: true } })
        } else if (!this.state.password) {
            this.props.showToast('error', strings.error_providePassword)
            this.setState({ errors: { password: true } })
        } else {
            this.setState({ loading: true, errors: {} })
            getDefaultDevice(false, window.navigator.language).then(data => {
                LoginAPI.login(this.state.email!, this.state.password!, data).then((device) => {
                    KDGlobal.instance.setUser(device.user!, device)
                    if (!(device.user as User).verified) {
                        this.props.history.push('/verify')
                    } else {
                        sessionStorage.setItem('loggedIn', 'true')
                        this.props.history.push({ pathname: '/app/dashboard' })
                    }
                }).catch((err: APIError) => {
                    if (err.type == APIErrorType.ResourceNotFound) {
                        this.props.showToast('error', strings.error_emailNotFound)
                        this.setState({ errors: { email: true }, loading: false })
                    } else {
                        this.props.showToast('error', strings.error_invalidLogin)
                        this.setState({ errors: { email: true, password: true }, loading: false })
                    }
                })
            })
        }
    }

    public render() {
        const { classes } = this.props;
        return <>
            <WelcomeHeader />
            <main className={classes.main}>
                <CssBaseline />

                <Paper className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        {strings.sign_in}
                    </Typography>
                    <form className={classes.form}>
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="email">{strings.emailAddress}</InputLabel>
                            <KDInput onEnterKey={this.onLoginClick.bind(this)} error={this.state.errors.email}
                                id="email" type="email" name="email" autoComplete="email"
                                autoFocus onChange={(e) => this.setState({ email: e.target.value })} value={this.state.email} />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="password">{strings.password}</InputLabel>
                            <KDInput onEnterKey={this.onLoginClick.bind(this)}
                                error={this.state.errors.email} name="password" type="password" id="password"
                                autoComplete="current-password"
                                onChange={(e) => this.setState({ password: e.target.value })} value={this.state.password} />
                        </FormControl>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={this.state.loading}
                            onClick={this.onLoginClick.bind(this)}
                            className={classes.submit}>
                            {strings.sign_in}
                        </Button>
                        <Button
                            fullWidth
                            variant='outlined'
                            color="secondary"
                            disabled={this.state.loading}
                            onClick={() => this.props.history.push('/sign-up')}
                            className={classes.submit}>
                            {strings.or_sign_up}
                        </Button>
                    </form>
                    {this.state.loading && <CircularProgress variant={'indeterminate'} size={24} className={classes.loader} />}
                </Paper>
            </main>
        </>
    }
}

const styles = (theme: Theme) => createStyles(({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    loader: {
        marginTop: theme.spacing()
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: theme.spacing(),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
}));

export default (withStyles(styles)(defaultView(Login) as any))


// WEBPACK FOOTER //
// ./src/components/Login/Login.tsx